let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page766_game1/img/bcg.jpg',
    pos: {
      x: 180,
      y: 0,
    },
    width: 1554,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page766_game1/audio/75_costume.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game1/img/audioOn.png', iconOff: 'games/page766_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 770,
        x: 1595,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game1/audio/75_costume.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game1/img/audioOn.png', iconOff: 'games/page766_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 725,
        x: 1035,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game1/audio/75_costume.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game1/img/audioOn.png', iconOff: 'games/page766_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 770,
        x: 680,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game1/audio/76_dino.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game1/img/audioOn.png', iconOff: 'games/page766_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 200,
        x: 1415,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game1/audio/77_clown.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game1/img/audioOn.png', iconOff: 'games/page766_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 150,
        x: 475,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game1/audio/78_pirate.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game1/img/audioOn.png', iconOff: 'games/page766_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: -10,
        x: 1015,
      },
      unit: 'px',
    },
  ],
};

export default elements;
